<div class="card">
    <div class="card-header">
        <h5 class="my-auto">Subscriptions</h5>
    </div>
    <div class="card-body">
        <ul class="list-group scrollable" style="height: 296px;">
            <li class="list-group-item list-group-item-action" [ngClass]="isFranchiseOwner() ? 'remove-events' : ''" (click)="isFranchiseOwner() ? null : openUpdateSubscriptionModal()">
                <div class="d-flex">
                    <div>
                        <div class="d-flex">
                            <strong>{{subscription?.name}}</strong>
                            @switch (subscription?.organizationStatus) {
                            @case ("ACTIVE") {
                            <span class="badge text-bg-success my-auto ms-2">Active</span>
                            }
                            @case ("TRIAL") {
                            <span class="badge text-bg-warning my-auto ms-2">Trial</span>
                            }
                            @case ("EXPIRING") {
                            <span class="badge text-bg-warning my-auto ms-2">Expiring</span>
                            }
                            @case ("DELINQUENT") {
                            <span class="badge text-bg-danger my-auto ms-2">Delinquent</span>
                            }
                            @case ("INACTIVE") {
                            <span class="badge text-bg-danger my-auto ms-2">Inactive</span>
                            }
                            }
                        </div>
                        @switch (subscription?.organizationStatus) {
                        @case ("ACTIVE") {
                        <small class="text-muted">Renews on {{subscription?.renewalDate | formatDateTime: true}}</small>
                        }
                        @case ("TRIAL") {
                        <small class="text-muted">Trial Ending on {{subscription?.renewalDate | formatDateTime: true}}</small>
                        }
                        @case ("EXPIRING") {
                        <small class="text-danger">Expires on {{subscription?.renewalDate | formatDateTime: true}}</small>
                        }
                        @case ("INACTIVE") {
                        <small class="text-danger">Expired on {{subscription?.renewalDate | formatDateTime: true}}</small>
                        }
                        }
                    </div>
                    <div class="ms-auto my-auto fs-4">
                        <span>${{ getPrice(subscription?.price) }}</span>
                        <span *ngIf="subscription?.frequency == 'MONTHLY'" style="font-size: 16px;">/month</span>
                        <span *ngIf="subscription?.frequency == 'ANNUALLY'" style="font-size: 16px;">/year</span>
                    </div>
                </div>
            </li>
            <li *ngIf="!subscription" class="list-group-item">No Subscription</li>
        </ul>
    </div>
</div>
